import { useSelector } from "react-redux";
import { Roles } from "@evennt-tech/api-v2-core";
import { OrganiserCompanyToOrganiserRole } from "@evennt-tech/api-v2-core/dist/organiser-company/enums";
import { selectUser } from "store/auth/selectors";
import useOrganiser from "./useOrganiser";

export default (): boolean => {
  const { role } = useSelector(selectUser);
  const [organiser] = useOrganiser();

  return (
    role === Roles.ORGANISER &&
    !!organiser &&
    organiser.organiserCompanyToOrganisers?.[0]?.role !==
      OrganiserCompanyToOrganiserRole.ADMIN
  );
};
